import axios from '../utils/http'

// 商品分类 / 产品类型
export const commerceClassfiyGet = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/goodType/list`,
    method: 'get',
    params
  })

export const commerceGoodTypeListAll = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/goodType/listAll`,
    method: 'get',
    params
  })
//---------------------// 商品轮播图
// 商品轮播图
export const commerceGoodBannerGet = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/goodBanner/list`,
    method: 'get',
    params
  })


// 商品轮播图 新增
export const commerceGoodBannerAdd = (data) =>
  axios({
    url: `/jeecg-boot/shuangpang/goodBanner/add`,
    method: 'post',
    data
  })

// 商品轮播图 编辑
export const commerceGoodBannerEdit = (data) =>
  axios({
    url: `/jeecg-boot/shuangpang/goodBanner/edit`,
    method: 'post',
    data
  })

// 商品轮播图 删除
export const commerceGoodBannerDelete = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/goodBanner/delete`,
    method: 'delete',
    params
  })

//---------------------// 官网首页视频轮播
export const commerceHomeVideoGet = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/websiteHomeVideo/list`,
    method: 'get',
    params
  })

export const commerceHomeVideoAdd = (data) =>
  axios({
    url: `/jeecg-boot/shuangpang/websiteHomeVideo/add`,
    method: 'post',
    data
  })

export const commerceHomeVideoEdit = (data) =>
  axios({
    url: `/jeecg-boot/shuangpang/websiteHomeVideo/edit`,
    method: 'post',
    data
  })

export const commerceHomeVideoDelete = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/websiteHomeVideo/delete`,
    method: 'delete',
    params
  })

//---------------------// 官网合作留言
export const commerceContactMessageGet = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/websiteContactMessage/list`,
    method: 'get',
    params
  })

export const commerceContactMessageQueryById = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/websiteContactMessage/queryById`,
    method: 'get',
    params
  })

export const commerceContactMessageMarkRead = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/websiteContactMessage/markRead`,
    method: 'post',
    params
  })

export const commerceContactMessageDelete = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/websiteContactMessage/delete`,
    method: 'delete',
    params
  })

//---------------------// 官网产品展示（弹层 + 首页大展示）
export const commerceProductDisplayGet = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/websiteProductModel/list`,
    method: 'get',
    params
  })

export const commerceProductDisplayQueryById = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/websiteProductModel/queryById`,
    method: 'get',
    params
  })

export const commerceProductDisplayAdd = (data) =>
  axios({
    url: `/jeecg-boot/shuangpang/websiteProductModel/add`,
    method: 'post',
    data
  })

export const commerceProductDisplayEdit = (data) =>
  axios({
    url: `/jeecg-boot/shuangpang/websiteProductModel/edit`,
    method: 'post',
    data
  })

export const commerceProductDisplayDelete = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/websiteProductModel/delete`,
    method: 'delete',
    params
  })

/** 腾讯云 COS 临时上传凭证（管理后台浏览器直传大视频） */
export const commerceCosCredential = () =>
  axios({
    url: `/jeecg-boot/shuangpang/cos/credential`,
    method: 'get'
  })

/** 腾讯云 COS 请求签名（服务端本地计算，不走 STS） */
export const commerceCosAuthorization = (data) =>
  axios({
    url: `/jeecg-boot/shuangpang/cos/authorization`,
    method: 'post',
    data
  })

//---------------------// 商品种类
export const commerceGoodTypeAdd = (data) => // 新增
  axios({
    url: `/jeecg-boot/shuangpang/goodType/add`,
    method: 'post',
    data
  })

export const commerceGoodTypeEdit = (data) => // 编辑
  axios({
    url: `/jeecg-boot/shuangpang/goodType/edit`,
    method: 'post',
    data
  })


export const commerceGoodTypeDelete = (params) => // 编辑
  axios({
    url: `/jeecg-boot/shuangpang/goodType/delete`,
    method: 'delete',
    params
  })

//-----------------------------------商品
// 商品管理
export const commerceGoodListGet = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/good/list`,
    method: 'get',
    params
  })

// 商品管理 详情
export const commerceQueryByIdGet = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/good/queryById`,
    method: 'get',
    params
  })


// 商品管理 添加
export const commerceGoodAdd = (data) =>
  axios({
    url: `/jeecg-boot/shuangpang/good/add`,
    method: 'post',
    data
  })

// 商品管理 编辑
export const commerceGoodEdit = (data) =>
  axios({
    url: `/jeecg-boot/shuangpang/good/edit`,
    method: 'post',
    data
  })

// 商品管理 删除
export const commerceGoodDelete = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/good/delete`,
    method: 'delete',
    params
  })

// 商品管理 运费模板-----------------------------------------------------------------------------------
// 运费模板
export const commerceDeliveryFeeListGet = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/deliveryFee/list`,
    method: 'get',
    params
  })



// 商品管理 订单-----------------------------------------------------------------------------------
// 订单
export const commerceUserhomeOrderListGet = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/userhomeOrder/list`,
    method: 'get',
    params
  })


// 订单 删除
export const commerceUserhomeOrderListDelete = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/userhomeOrder/delete`,
    method: 'delete',
    params
  })

// 订单 详情
export const commerceUserhomeOrderQueryByIdGet = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/userhomeOrder/queryById`,
    method: 'get',
    params
  })

// 订单 发货
export const commerceUserhomeOrderLogistics = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/userhomeOrder/logistics`,
    method: 'post',
    params
  })

// 订单 物流订单
export const commerceUserhomeOrderQueryExpress = (params) =>
  axios({
    url: `/jeecg-boot/front/order/queryExpress`,
    method: 'post',
    params
  })


//---------------------------

// 售后订单
export const commerceUserhomeOrderAfterListGet = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/userhomeOrderAfter/list`,
    method: 'get',
    params
  })

// 售后订单 详情
export const commerceUserhomeOrderAfterQueryByIdGet = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/userhomeOrderAfter/queryById`,
    method: 'get',
    params
  })

// 售后订单 处理
export const commerceUserhomeOrderAfterEditPost = (data) =>
  axios({
    url: `/jeecg-boot/shuangpang/userhomeOrderAfter/edit`,
    method: 'post',
    data
  })

//--------------------快递100
export const commerceKuaidi100List = (params) =>
  axios({
    url: `/jeecg-boot/shuangpang/kuaidi100/list`,
    method: 'get',
    params
  })